import React from "react";
import DualColumn from "../ui/dual-column";
import { cn } from "@/utils";
// import LottieAnimation from "@/components/lottie";
// import Cloud from "@animations/ror-migration-services/our-services/cloud.json";
// import Legacy from "@animations/ror-migration-services/our-services/legacy.json";
// import Migration from "@animations/ror-migration-services/our-services/migration.json";
// import Performance from "@animations/ror-migration-services/our-services/performance.json";
import legacy from "../../images/service-list/ror-migrate/legacy.svg";
import performance from "../../images/service-list/ror-upgrade/optimization.svg";
import codeReview from "../../images/service-list/home-page/code-review.svg";
import database from "../../images/service-list/custom-software/database-design.svg";
import UIUX from "../../images/service-list/home-page/ui-ux.svg";
import cloud from "../../images/service-list/ror-upgrade/cloud-migration.svg";
import { graphql, useStaticQuery } from "gatsby";
import { h2, pl } from "../ui/typography/typography.module.css";
interface ServicesProps extends React.HTMLProps<HTMLDivElement> {}

interface RorMigrationServicesList {
  ourServiceTitleOne: string;
  ourServiceDescriptionOne: string;
  ourServiceTitleTwo: string;
  ourServiceDescriptionTwo: string;
  ourServiceTitleThree: string;
  ourServiceDescriptionThree: string;
  ourServiceTitleFour: string;
  ourServiceDescriptionFour: string;
  ourServiceTitleFive: string;
  ourServiceDescriptionFive: string;
  ourServiceTitleSix: string;
  ourServiceDescriptionSix: string;
  ourServiceTitleSeven: string;
  ourServiceDescriptionSeven: string;
}
interface RorMigrationPageServices {
  allStrapiRorMigrationServicePage: {
    nodes: RorMigrationServicesList[];
  };
}
const Services: React.FC<ServicesProps> = ({ className }) => {
  const data: RorMigrationPageServices = useStaticQuery(graphql`
    query RorMigrationPageServices {
      allStrapiRorMigrationServicePage {
        nodes {
          ourServiceTitleOne
          ourServiceDescriptionOne
          ourServiceTitleTwo
          ourServiceDescriptionTwo
          ourServiceTitleThree
          ourServiceDescriptionThree
          ourServiceTitleFour
          ourServiceDescriptionFour
          ourServiceTitleFive
          ourServiceDescriptionFive
          ourServiceTitleSix
          ourServiceDescriptionSix
          ourServiceTitleSeven
          ourServiceDescriptionSeven
        }
      }
    }
  `);
  const query = data.allStrapiRorMigrationServicePage.nodes;
  return (
    <section className={cn("mt-20 md:mt-32", className)}>
      {query.map((result) => (
        <>
          <DualColumn
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Legacy} alt="Legacy Application" /> */}
                <img src={legacy} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleOne}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionOne}</p>
              </div>
            }
          ></DualColumn>
          {/* <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                <LottieAnimation animationData={Performance} alt="Performance optimization" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <H2>{result.ourServiceTitleTwo}</H2>
                <PL className="mt-4 md:mt-6">{result.ourServiceDescriptionTwo}</PL>
              </div>
            }
          ></DualColumn> */}
          <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Migration} alt="Custom migration" /> */}
                <img src={performance} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleThree}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionThree}</p>
              </div>
            }
          ></DualColumn>
          <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Legacy} alt="Legacy Application" /> */}
                <img src={codeReview} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleFive}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionFive}</p>
              </div>
            }
          ></DualColumn>
          <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Performance} alt="Performance optimization" /> */}
                <img src={database} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleSix}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionSix}</p>
              </div>
            }
          ></DualColumn>
          <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Cloud} alt="Cloud services" /> */}
                <img src={UIUX} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleSeven}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionSeven}</p>
              </div>
            }
          ></DualColumn>
          <DualColumn
            className="mt-20 md:mt-24"
            firstColumnClassName="flex items-center md:justify-center"
            firstColumn={
              <div className="md:p-6">
                {/* <LottieAnimation animationData={Cloud} alt="Cloud services" /> */}
                <img src={cloud} alt="Legacy application" />
              </div>
            }
            lastColumnClassName="flex items-center justify-center"
            lastColumn={
              <div className="flex flex-col w-full mt-8 md:mt-0 md:p-6">
                <h3 className={h2}>{result.ourServiceTitleFour}</h3>
                <p className={`${pl} mt-4 md:mt-6`}>{result.ourServiceDescriptionFour}</p>
              </div>
            }
          ></DualColumn>
        </>
      ))}
    </section>
  );
};

export default Services;
